import Modal from './modal';
import { showVideoModal } from '../util/modal-helpers';

class ModalVideoPopup {
	constructor(el) {
		this.el = el;
		this.emblaInstances = [];

		this.initializeModals();
	}

	initializeModals = () => {
		const btnModalLoading = this.el.querySelector('.js__modal--loading');
		const btnModalVideo = this.el;

		if (btnModalLoading) {
			btnModalLoading.addEventListener('click', () => {
				Modal.show();

				setTimeout(() => {
					Modal.setContent('This content was set after a 2 second delay.');
				}, 2000);
			});
		}

		if (btnModalVideo) {
			btnModalVideo.addEventListener('click', (e) => {
				const trigger = e.currentTarget;
				const videoURL = trigger.getAttribute('data-video-url');

				if (!videoURL) {
					console.error('No video URL found');
					return;
				}

				showVideoModal(videoURL, {
					title:
						trigger.getAttribute('data-video-title') ||
						trigger.getAttribute('aria-label') ||
						'Video',
					captions: trigger.getAttribute('data-video-captions') || '',
					transcript: trigger.getAttribute('data-video-transcript') || '',
					audioDescribedUrl: trigger.getAttribute('data-video-audio-described-url') || '',
					isSilent: trigger.getAttribute('data-video-is-silent') === 'true',
					restoreFocusElement: trigger
				});
			});
		}
	};
}

export default ModalVideoPopup;